import { Signal } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { System } from 'app/api';

export function getDmTransactionsFields(
    systems: System[],
    disabled: boolean,
    translocoContent: Signal<any>
): FormlyFieldConfig[] {
    const prefix = 'systemTables.dmTransactions.';
    return [
        // {
        //     className: 'flex-1',
        //     type: 'select',
        //     key: 'system',
        //     props: {
        //         label: translocoContent()[prefix + 'system'],
        //         required: true,
        //         disabled: disabled,
        //         options: systems
        //             .filter(system => system.status === 'ACTIVE')
        //             .map(system => {
        //                 return {
        //                     label: system.title,
        //                     value: system.title,
        //                 };
        //             }),
        //     },
        // },
        {
            className: 'flex-1',
            type: 'md-object-dialog',
            key: 'system',
            props: {
                label: translocoContent()[prefix + 'system'],
                required: true,
                disabled: disabled,
                valueProp: 'id',
                labelProp: 'title',
                attributes: {
                    selectionType: 'system',
                },
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'tcode',
            props: {
                label: translocoContent()[prefix + 'tcode'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'name',
            props: {
                label: translocoContent()[prefix + 'name'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1 hidden',
            type: 'input',
            key: 'description',
            props: {
                label: translocoContent()[prefix + 'description'],
                required: false,
                disabled: disabled,
            },
            defaultValue: '',
        },
    ];
}
